import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default class RowGroup extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    collapsed: PropTypes.bool
  }

  render() {
    const {color, collapsed} = this.props
    const className = classnames('table-row-group', {
      [`is-${color}`]: color,
      'is-collapsed': collapsed
    })
    return (
      <div className={className}>{this.props.children}</div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Table/RowGroup.js